import { Box, Typography } from '@mui/material'
import { memo } from 'react'
import { Handle, Position } from 'reactflow'
import { useTranslation } from 'react-i18next'

interface LogoNodeProps {
    data: any
    isConnectable: any
}

export default memo((props: LogoNodeProps) => {
    const { data, isConnectable } = props
    const { t } = useTranslation()

    return (
        <Box className="logo-node">
            <Handle
                id={data.label + '-target'}
                type="target"
                position={Position.Top}
                isConnectable={isConnectable}
            />
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    background: '#fff',
                    border: '1px solid #000',
                    borderRadius: '3px',
                    padding: '5px 7px 5px 5px',
                    gap: '4px',
                    // minWidth: '200px',
                }}
                justifyContent="center"
            >
                <Box
                    sx={{ filter: 'brightness(0)' }}
                    height="20px"
                    width="20px"
                >
                    {' '}
                    {data.logo ? (
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                            src={data.logo}
                            loading="lazy"
                            alt={
                                data.label
                                    ? t('workflowLogoFor', {
                                          label: data.label,
                                      })
                                    : t('workflowLogo')
                            }
                            title={
                                data.label
                                    ? t('workflowLogoFor', {
                                          label: data.label,
                                      })
                                    : t('workflowLogo')
                            }
                        />
                    ) : (
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                            src="/assets/images/icons/Truck-Icon.svg"
                            loading="lazy"
                            alt={t('truckWorkflowIcon')}
                        />
                    )}
                </Box>
                <Typography
                    fontSize="10px"
                    sx={{
                        marginTop: '2px',
                    }}
                >
                    {data.label}
                </Typography>
            </Box>
            <Handle
                type="source"
                position={Position.Bottom}
                id="a"
                isConnectable={isConnectable}
            />
        </Box>
    )
})
